import { render, staticRenderFns } from "./locations-list.vue?vue&type=template&id=34c85482"
import script from "./locations-list.vue?vue&type=script&lang=ts"
export * from "./locations-list.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports